import React, { useState } from 'react';
import '../../../styles/SelectCoin/CoinCard.css'; 
import { toDollarSmall, toAbbreviatedDollar, toDollar } from '../../../helpers/helperFunctions';
import { IoMdInformationCircleOutline, IoMdArrowRoundBack } from "react-icons/io";
import CryptoLineChart from './CryptoLineChart';
import { IoIosArrowUp, IoIosArrowDown,  } from "react-icons/io";

const CoinCard = ({ coin, multicryptoRate, logo, handleCoinSelect, chainLogo }) => {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleInfoClick = (e) => {
    e.stopPropagation();
    setIsFlipped(!isFlipped);
  };

  let isUp = multicryptoRate && multicryptoRate.chart && multicryptoRate.chart.performance && multicryptoRate.chart.performance.percentage > 0;

  let isStable = false;

  // NOTE: SHOULD COME FROM UNITY WHEN WE HAVE CATEGORIES
  if(coin.ticker === 'USDC' || coin.ticker === 'USDT') {
    isStable = true;
  }

  return (
    <div className={`coin-card-container ${isFlipped ? 'is-flipped' : ''}`}>
      <div className="coin-card-flipper">
        {/* Front of card */}
        <div className="coin-card front" onClick={handleCoinSelect}>
          <div className="coin-card-header">
            <img className="coin-logo" src={logo} alt={coin.name} />
            {chainLogo && <img className="chain-logo" src={chainLogo} alt={coin.chain.name} />}
            <div className="coin-name-container">
              <h3 className="coin-name">{coin.name}</h3>
              {multicryptoRate && <h4 className="coin-price">${ toDollarSmall(multicryptoRate.price)}</h4>}
            </div>
          </div>
          <div className="coin-card-details">
            {multicryptoRate && <div className='market-cap-details'>
              <p className="detail-label">Market cap <span className="detail-value">${toAbbreviatedDollar(multicryptoRate.market_cap)}</span></p>
            </div>}
          </div>
          {multicryptoRate && multicryptoRate.chart && (
            <button className="info-btn" onClick={handleInfoClick}>
              <IoMdInformationCircleOutline />
            </button>
          )}
        </div>

        {/* Back of card */}
        {multicryptoRate && multicryptoRate.chart && (
          <div className="coin-card back" onClick={(e) => {
            e.stopPropagation();
            handleInfoClick(e);
          }}>
            <div className="coin-card-header back">
              <img className="coin-logo back" src={logo} alt={coin.name} />
              <div className="coin-name-container">
                <h3 className="coin-name back">{coin.name} <span className="coin-ticker-card">({coin.ticker})</span></h3>
                {multicryptoRate && <h4 className="coin-price back">${toDollarSmall(multicryptoRate.price)}</h4>}
              </div>
            </div>
            <div className="coin-card-details back">
              <CryptoLineChart data={multicryptoRate.chart.data} up={isUp} isStable={isStable} />
              <div className="coin-card-performance">
                {/* period button */}
                <div className="coin-card-performance-time-period">
                  3M
                </div>

                {/* performance badge */}
                <div className={`coin-card-performance-badge ${(isStable || isUp) ? 'green-performance' : 'red-performance'}`}>
                  { isStable ? null :
                  isUp ? <IoIosArrowUp className="inline-block mr-1" /> : <IoIosArrowDown className="inline-block mr-1" />}
                  ${toDollarSmall(multicryptoRate.chart.performance.value)} ({multicryptoRate.chart.performance.percentage}%)
                </div>
              </div>
            </div>
            <div className="coin-card-description">
              <p>
                {multicryptoRate.description}
              </p>
            </div>
            <button className="info-btn-back">
              <IoMdArrowRoundBack />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CoinCard;